<div class="header create">
  <button mat-icon-button (click)="navigateBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h3>Nuova configurazione</h3>
</div>
<mat-card>
  <form [formGroup]="creationForm" (ngSubmit)="submitForm()">
    <mat-form-field>
      <mat-label>Codice touchpoint</mat-label>
      <input matInput formControlName="touchpointCode" required />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Codice macromanifestazione</mat-label>
      <input matInput formControlName="exhibitionGroupCode" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Codice manifestazione</mat-label>
      <input matInput formControlName="exhibitionCode" />
    </mat-form-field>
    <br />


    <mat-form-field>
      <mat-label>Codice TP TrustGuardian</mat-label>
      <input matInput formControlName="tgTouchpointConfigCode" required />
    </mat-form-field>

    <br />

    <mat-form-field>
      <mat-label>Descrizione</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <br />

    <mat-checkbox formControlName="skipValidation">Salta validazione</mat-checkbox>

    <button mat-raised-button color="primary" type="submit" [disabled]="creationForm.invalid || isSubmitting">
      <ng-container *ngIf="!isSubmitting">Salva</ng-container>
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
    </button>
  </form>
</mat-card>
